import {apiFetch, apiPostCustomBody} from "@/utils";

function getComingAppointments(globalView = false) {
  return apiFetch("dashboard-cdm/appointments/get?globalView=" + globalView, false, false);
}

function getPrestations(year, globalView = false) {
  return apiFetch("dashboard-cdm/prestations/get?year=" + year + "&globalView=" + globalView, false, false);
}

function getStatsRecap(periodId, globalView = false) {
  return apiFetch("dashboard-cdm/stats/get?periodId=" + periodId + "&globalView=" + globalView, false, false);
}

function getStatsAlerts(globalView = false) {
  return apiFetch("dashboard-cdm/stats/alerts?globalView=" + globalView, false, false);
}

function getEllisphereAlerts(globalView = false) {
  return apiFetch("dashboard-cdm/ellisphere/alerts?globalView=" + globalView, false, false);
}

function getSimFixeAlertesBaisse(globalView = false) {
  return apiFetch("dashboard-cdm/sim-fixe/alertes-baisse?globalView=" + globalView, false, false);
}

function getSimFixePaliersSup(globalView = false) {
  return apiFetch("dashboard-cdm/sim-fixe/paliers-sup?globalView=" + globalView, false, false);
}

// region Page Rendez-vous

function getRecapFrs(frsGuid) {
  return apiFetch("dashboard-cdm/rdv/recap-frs?frsGuid=" + frsGuid, false, false);
}

function getContactFrs(frsGuid) {
  return apiFetch("dashboard-cdm/rdv/contact-frs?frsGuid=" + frsGuid, false, false);
}

function getPaymentsFrs(frsGuid) {
  return apiFetch("dashboard-cdm/rdv/payments-frs?frsGuid=" + frsGuid, false, false);
}

function getFrsCaRfaInfos(frsGuid) {
  return apiFetch("dashboard-cdm/rdv/infos-carfa-frs?frsGuid=" + frsGuid, false, false);
}

function getFrsGammesCaRfaInfos(frsGuid) {
  return apiFetch("dashboard-cdm/rdv/infos-gammes-carfa-frs?frsGuid=" + frsGuid, false, false);
}

function getFrsRulesRfaInfos(frsGuid) {
  return apiFetch("dashboard-cdm/rdv/infos-rules-rfa-frs?frsGuid=" + frsGuid, false, false);
}

function getFrsPrestasInfos(frsGuid) {
  return apiFetch("dashboard-cdm/rdv/infos-prestas-frs?frsGuid=" + frsGuid, false, false);
}

function getCommentFrs(body) {
  return apiFetch("dashboard-cdm/rdv/comment?FrsGuid=" + body.FrsGuid + "&Year=" + body.Year + "&IsAdvance=" + body.IsAdvance + "&Concept=" + body.Concept, false, false);
}

function saveCommentFrs(body) {
  return apiPostCustomBody("dashboard-cdm/rdv/comment", body);
}

// endregion

export {
  getComingAppointments,
  getPrestations,
  getStatsRecap,
  getRecapFrs,
  getContactFrs,
  getPaymentsFrs,
  getFrsCaRfaInfos,
  getFrsGammesCaRfaInfos,
  getFrsRulesRfaInfos,
  getFrsPrestasInfos,
  getCommentFrs,
  saveCommentFrs,
  getSimFixeAlertesBaisse,
  getSimFixePaliersSup,
  getStatsAlerts,
  getEllisphereAlerts
}



// WEBPACK FOOTER //
// ./src/utils/dashboardCdm.js